<script setup lang="ts">
import { useBreakpoints } from "../lib/useBreakpoints";

const props = defineProps<{
  // TODO: refactor to modelValue when updated to use v-model upstream
  value: string;
  restricted?: boolean;
}>();

const emit = defineEmits<{
  (e: "change"): void;
  // TODO: refactor to update:modelValue when updated to use v-model upstream
  (e: "user-input", value: string): void;
}>();

const { mdAndUp } = useBreakpoints();

function handleEmit(newTab: string) {
  if (props.value !== newTab) {
    emit("user-input", newTab);
  }
}
</script>

<template>
  <div>
    <Tabs
      :value="value"
      @update:value="handleEmit($event as string)"
      v-tooltip.top="
        restricted
          ? 'Sign in to see more details and ask questions about this RFP'
          : undefined
      "
    >
      <TabList>
        <Tab href="#timeline" value="timeline" class="tw:w-1/3">
          <div class="tw:flex tw:items-center tw:gap-2">
            <TIcon :left="mdAndUp">event</TIcon>
            <span v-if="mdAndUp">Timeline</span>
          </div>
        </Tab>
        <Tab
          href="#disclosures"
          value="disclosures"
          :disabled="restricted"
          class="tw:w-1/3"
        >
          <div class="tw:flex tw:items-center tw:gap-2">
            <TIcon :left="mdAndUp">table_chart</TIcon>
            <span v-if="mdAndUp">Disclosures</span>
          </div>
        </Tab>
        <Tab
          href="#questions-answers"
          value="questions-answers"
          :disabled="restricted"
          class="tw:w-1/3"
        >
          <div class="tw:flex tw:items-center tw:gap-2">
            <TIcon :left="mdAndUp">forum</TIcon>
            <span v-if="mdAndUp">Q&amp;A</span>
          </div>
        </Tab>
      </TabList>
      <TabPanels>
        <TabPanel value="timeline">
          <slot name="timeline" />
        </TabPanel>
        <TabPanel value="disclosures">
          <slot name="disclosures" />
        </TabPanel>
        <TabPanel value="questions-answers">
          <slot name="questions" />
        </TabPanel>
      </TabPanels>
    </Tabs>
  </div>
</template>
